import { dataEmpty } from "components/CommonLib/CommonLib";
import { VAULT_CASH_TYPE } from "components/CommonLib/Consts";
import CustomPagination from "components/CustomPagination/CustomPagination";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import {
  CustomRow,
  CustomTableContents,
  CustomTableContentsEND,
} from "components/CustomTable/tableStyle";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";

const VaultCashResultTable = ({
  searchResult,
  curPage,
  totalPage,
  onClickSearch,
  onClickExcelDownload,
  vaultCashBalance,
}) => {
  const searchResultList = new resultTable();

  const doSearch = (page) => {
    onClickSearch(page);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "0.5rem",
          gap: "0.25rem",
        }}
      >
        <TextField
          labelText={`현재 시재금 \u00A0\u00A0 :`}
          labelWidth="6.5rem"
          marginLeft="0.875rem"
          textBoxWidth="13rem"
          textMarginRight="0rem"
          isNumber={vaultCashBalance !== null}
          textAlign="center"
          inputPadding="10px 0px 8.5px 15px"
          defaultValue={
            vaultCashBalance === null
              ? "지점 선택이 필요합니다."
              : vaultCashBalance.toLocaleString()
          }
          endAdornment={vaultCashBalance === null ? "" : "원"}
          disabled
        />
        <NormalBtn theme="green" name="엑셀 다운로드" onClick={onClickExcelDownload} />
      </div>
      <CustomTable
        columns_head={searchResultList.columns_head}
        table_title={searchResultList.table_title}
        rest_call={searchResultList.get_data_from_rest}
        row_render={searchResultList.create_table}
        rest_data={searchResult}
      />
      <CustomPagination curPage={curPage} totalCnt={totalPage} doSearch={doSearch} />
    </div>
  );
};
export default VaultCashResultTable;

class resultTable {
  create_table = (data, idx) => {
    return (
      <CustomRow style={{}} key={idx}>
        <CustomTableContents>{data.reg_date}</CustomTableContents>
        <CustomTableContents>{data.branch_info.branch_name}</CustomTableContents>
        <CustomTableContents>
          {" "}
          {data.vault_type === "지출" ? VAULT_CASH_TYPE.EXPENSE : data.vault_type}
        </CustomTableContents>
        <CustomTableContents $isNumber>{data.price.toLocaleString() + " 원"}</CustomTableContents>
        <CustomTableContents>{data.note}</CustomTableContents>
        <CustomTableContentsEND>{data.reg_info.reg_name}</CustomTableContentsEND>
      </CustomRow>
    );
  };

  columns_head = [
    { title: "날짜", width: "10%" },
    { title: "지점", width: "10%" },
    { title: "시재금 입출 구분", width: "10%" },
    { title: "금액", width: "15%" },
    { title: "내용", width: "40%" },
    { title: "담당자", width: "15%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
